export const convertSpeedToMpH = (metersPerSecond: number) => +(metersPerSecond * 2.237).toFixed(1); // constant has taken from google
export const convertSpeedFromMpH = (milesPerHour: number) => +(milesPerHour / 2.237).toFixed(5); // constant has taken from google
